<template>
  <div>
    <div class="closepass-button">
      <Button
        @click="pushBack"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-plain"
      />
    </div>
    <div v-if="this.isLoading" class="passenger-card__skeleton-wrapper">
      <Skeleton class="passenger-card__skeleton" width="260px" height="24px" />
      <Skeleton class="passenger-card__skeleton" width="140px" height="20px" />
      <Skeleton class="passenger-card__skeleton" width="200px" height="20px" />
      <Skeleton class="passenger-card__skeleton" width="220px" height="20px" />
      <Skeleton class="passenger-card__skeleton" width="280px" height="20px" />
      <Skeleton class="passenger-card__skeleton" width="220px" height="20px" />
      <Skeleton class="passenger-card__skeleton" width="280px" height="20px" />
    </div>
    <div v-else>
      <div
        class="choosen-order__info-passengers__descr-wrapper"
        v-for="(passenger, index) in this.passengers.order.Passengers"
        :key="index"
      >
        <p class="choosen-order__info-passengers__descr-title">
          {{
            passenger.LastName +
            " " +
            passenger.FirstName +
            " " +
            passenger.MiddleName
          }}
        </p>
        <div class="choosen-order__info-passengers__descr-gender">
          <p class="choosen-order__info-passengers__descr-gender__title">
            Пол:
          </p>
          &nbsp;
          <p v-if="passenger.Gender == 0">Мужской</p>
          <p v-else>Женский</p>
        </div>
        <div class="choosen-order__info-passengers__descr-citizen">
          <p class="choosen-order__info-passengers__descr-citizen__title">
            Гражданство:
          </p>
          &nbsp;
          <p>{{ passenger.Citizenship.CodeRus }}</p>
        </div>
        <div class="choosen-order__info-passengers__descr-birth">
          <p class="choosen-order__info-passengers__descr-birth__title">
            Дата рождения:
          </p>
          &nbsp;
          <p>{{ getDateWithDot(passenger.BirthDate) }}</p>
        </div>
        <div class="choosen-order__info-passengers__descr-doc">
          <p class="choosen-order__info-passengers__descr-doc__title">
            Документ:
          </p>
          &nbsp;
          <p>
            {{
              passenger.PassengerDocument.DocType.Description.charAt(
                0
              ).toUpperCase() +
              passenger.PassengerDocument.DocType.Description.slice(1)
            }}
          </p>
        </div>
        <div class="choosen-order__info-passengers__descr-docnum">
          <p class="choosen-order__info-passengers__descr-docnum__title">
            Номер документа:
          </p>
          &nbsp;
          <p>{{ passenger.PassengerDocument.DocNum }}</p>
        </div>
        <div
          v-if="
            passenger.PassengerDocument.DocType.CodeLat !== 'PS' &&
            passenger.PassengerDocument.DocType.CodeLat !== 'SR'
          "
          class="choosen-order__info-passengers__descr-expire"
        >
          <p class="choosen-order__info-passengers__descr-expire__title">
            Срок действия документа:
          </p>
          &nbsp;
          <p>
            {{ getDateWithDot(passenger.PassengerDocument.ExpirationDate) }}
          </p>
        </div>
        <div
          v-if="passenger.BonusCards.length > 0"
          class="choosen-order__info-passengers__descr-bonuscard"
        >
          <p class="choosen-order__info-passengers__descr-bonuscard__title">
            Бонусные карты:
          </p>
          <div
            v-for="(bonus, index) in passenger.BonusCards"
            :key="index"
            class="choosen-order__info-passengers__descr-bonuscard__item"
          >
            <p
              class="
                choosen-order__info-passengers__descr-bonuscard__item-airline
              "
            >
              {{ bonus.AirLine }}
            </p>
            &nbsp;
            <p
              class="
                choosen-order__info-passengers__descr-bonuscard__item-number
              "
            >
              {{ bonus.CardNumber }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ref } from "vue";
import useClipboard from "vue-clipboard3";
import Button from "primevue/button";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "OrderPassengersCard",
  components: {
    Button,
    Skeleton,
  },
  props: ["guid", "order"],
  setup(props) {
    const isLoading = ref(false);
    const error = ref(null);
    const router = useRouter();
    const route = useRoute();
    const passengers = ref(null);
    const getPassengers = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetOrderPassengers?guid=${props.order}`
        );
        let fetchedPass = await json.data;
        passengers.value = fetchedPass;
        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    return {
      isLoading,
      error,
      passengers,
      getPassengers,
    };
  },
  data() {
    return {
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    getDateWithDot(date: string): any {
      let parseDate = new Date(date);
      let day = parseDate.getDate();
      let month = parseDate.getMonth();
      let year = parseDate.getFullYear();
      return day + " " + this.month[month] + " " + year;
    },
    pushBack() {
      this.$router.back();
    },
  },
  created() {
    this.getPassengers();
  },
});
</script>

<style>
.closepass-button {
  text-align: right;
  padding-right: 10px;
}

.passenger-card__skeleton:first-child {
  margin-top: 0;
}

.passenger-card__skeleton {
  margin-top: 10px;
}

@media screen and (max-width: 767px) {
  .choosen-order__info-passengers__descr {
    min-height: 100vh;
  }

  .choosen-order__info-passengers__descr-btn {
    box-sizing: border-box;
    width: 100%;
    padding: 30px 45px;
    margin-top: 0;
    margin-bottom: auto;
  }

  .choosen-order__info-passengers__descr-wrapper {
    margin-top: 20px;
    margin-left: 5px;
  }

  .choosen-order__info-passengers__descr-wrapper:first-child {
    margin-top: 0;
  }

  .choosen-order__info-passengers__descr-title {
    color: #000;
    font-size: 18px;
    font-weight: bold;
  }

  .choosen-order__info-passengers__descr-gender {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-gender__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-citizen {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-citizen__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-birth {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-birth__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-doc {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-doc__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-docnum {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-docnum__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-expire {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-expire__title {
    color: #4e4e4e;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .choosen-order__info-passengers__descr-wrapper {
    margin-top: 20px;
    margin-left: 5px;
  }

  .choosen-order__info-passengers__descr-wrapper:first-child {
    margin-top: 0;
  }

  .choosen-order__info-passengers__descr-title {
    color: #000;
    font-size: 18px;
    font-weight: bold;
  }

  .choosen-order__info-passengers__descr-gender {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-gender__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-citizen {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-citizen__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-birth {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-birth__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-doc {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-doc__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-docnum {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-docnum__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-expire {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-expire__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr {
    background-color: #fff;
  }
}

@media screen and (min-width: 1025px) {
  .choosen-order__info-passengers__descr-wrapper {
    margin-top: 20px;
    margin-left: 5px;
  }

  .choosen-order__info-passengers__descr-wrapper:first-child {
    margin-top: 0;
  }

  .choosen-order__info-passengers__descr-title {
    color: #000;
    font-size: 20px;
    font-weight: bold;
  }

  .choosen-order__info-passengers__descr-gender {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-gender__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-citizen {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-citizen__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-birth {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-birth__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-doc {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-doc__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-docnum {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-docnum__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-expire {
    display: flex;
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-expire__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-bonuscard {
    margin-top: 10px;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr-bonuscard__title {
    color: #4e4e4e;
  }

  .choosen-order__info-passengers__descr-bonuscard__item {
    display: flex;
    margin-top: 5px;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    color: #000000;
  }

  .choosen-order__info-passengers__descr {
    background-color: #fff;
  }
}
</style>
